<template>
    <Card style="min-height: 500px;">
		<!--div style="margin-bottom: 20px;">
			<Button type="primary" slot="extra" @click="AddRecordClick">写日志</Button>
		</div-->
        <Tabs value="today_customer" :animated="false">

            <TabPane label="今日来访客户" name="today_customer">
               <TodayCustomer ref="TodayCustomer"></TodayCustomer>
            </TabPane>
			<TabPane label="个人来访报表" name="visiting_customer_report">
			   <VisitingCustomerReport ref="VisitingCustomerReport" :type='1'></VisitingCustomerReport>
			</TabPane>
			<TabPane label="团队来访报表" name="team_visiting_customer_report">
			   <VisitingCustomerReport ref="VisitingCustomerReport" :type='2'></VisitingCustomerReport>
			</TabPane>
            <TabPane label="我的日志" name="my_record">
				<div style="margin-bottom: 20px;">
					<Button type="primary" slot="extra" @click="AddRecordClick">写日志</Button>
				</div>
                <RecordList ref="recordList"></RecordList>
            </TabPane>
            <TabPane label="团队日志" name="team_record">
                <teamRecordList  ref="teamRecordList"></teamRecordList>
            </TabPane>
			<!--TabPane label="通时报表" name="call_report">
			    <CallReport  ref="CallReport" :type='1'></CallReport>
			</TabPane-->
        </Tabs>
        <!-- 写日志弹出框 -->
        <Modal v-model="addRecordShow" width="1000">
            <div style="font-size: 20px; font-weight: bold;">写日志</div>
            <Tabs v-model="tabs_value" :animated="false" @on-click="addTabsClick">
                <TabPane label="日报" name="day">
                    <div class="list_width"
                         style="display: flex; justify-content: space-between; width: 750px; margin-top: 20px;">
                        <div>
                            <span>今日上门客户：</span>
                            <span style="color: #277dd3;">{{staticData.view_nums}}位</span>
                        </div>
                        <div>
                            <span>今日签约客户：</span>
                            <span style="color: #277dd3;">{{staticData.sign_nums}}位</span>
                        </div>
                        <div>
                            <span>今日进件：</span>
                            <span style="color: #277dd3;">{{staticData.client_nums}}件</span>
                        </div>

                        <div>
                            <span>今日回款额度：</span>
                            <span>{{staticData.repay_money}}元</span>
                        </div>
                    </div>
                    <div class="list_width"
                         style="display: flex; justify-content: space-between; width: 750px; margin-top: 20px;">
                        <div>
                            <span>今日跟进客户数量：</span>
                            <span>{{staticData.follow_nums}}位</span>
                        </div>
                        <div>
                            <span>跟进次数：</span>
                            <span>{{staticData.follow_times}}次</span>
                        </div>
                        <div>
                            <span>通话次数：</span>
							<Input v-model="staticData.call_nums" placeholder="Enter something..." style="width: 50px" />次
                        </div>
                        <div>
                            <span>通话时长：</span>
							<Input v-model="staticData.call_time" placeholder="Enter something..." style="width: 50px" />分钟
                        </div>
                    </div>
					<div class="list_width"
					     style="display: flex; justify-content: space-between; width: 550px; margin-top: 20px;">
						 <div>
						     <span>业绩目标：</span>
						     <span>{{staticData.achievement}}</span>
						 </div>
						 <div>
							 <span>本月业绩：</span>
							 <span>{{staticData.month_repay_money}}</span>
						 </div>
						 <div>

						     <span><Progress :percent="staticData.achievement_rate" :stroke-width="20" status="active" text-inside /></span>
						 </div>
					</div>
					<div class="list_width"
					     style="display: flex; justify-content: space-between; width: 355px; margin-top: 5px;">

					</div>
					<div class="list_width" style="margin-top: 10px;font-weight: bold;">今日上门客户：</div>
					<div v-for="(item,index) in staticData.view_list">
						<Row style="margin-top: 20px;">
							<Col span="3">
								<span style="margin-left: 20px;">{{item.name}}</span>
							</Col>
							<Col span="8">
								<span style="padding-right: 10px;">上门结论</span>
								<Select v-model="item.status" style="width:200px">
									<Option v-for="item in stateList" :value="item.value" :key="item.value">
										{{ item.label }}
									</Option>
								</Select>
							</Col>
							<Col span="8">
								<Input v-model="item.view_remark" placeholder="请输入客户备注"/>
							</Col>
						</Row>
					</div>
					
                    <div class="list_width" style="margin-top: 10px;font-weight: bold;">今日工作总结：</div>
                    <Input v-model="staticData.summarize" type="textarea" :rows="4"/>
                    <div class="list_width" style="margin-top: 10px;font-weight: bold;">遇到的问题或明天需要协助的事项：</div>
                    <Input v-model="staticData.issue" type="textarea" :rows="4"/>
                </TabPane>
                <!--TabPane label="周报" name="week">
					<div class="list_width"
						 style="display: flex; justify-content: space-between; width: 946px; margin-top: 20px;">
						<div>
							<span>本周上门客户：</span>
							<span style="color: #277dd3;">{{staticData.view_nums}}位</span>
						</div>
						<div>
							<span>本周签约客户：</span>
							<span style="color: #277dd3;">{{staticData.sign_nums}}位</span>
						</div>
						<div>
							<span>本周进件：</span>
							<span style="color: #277dd3;">{{staticData.client_nums}}件</span>
						</div>
						<div>
							<span>本周放款：</span>
							<span style="color: #277dd3;">{{staticData.loan_money}}笔</span>
						</div>
						<div>
							<span>回款额度：</span>
							<span>{{staticData.repay_money}}元</span>
						</div>
					</div>
					<div class="list_width"
						 style="display: flex; justify-content: space-between; width: 750px; margin-top: 5px;">
						<div>
							<span>本周跟进客户数量：</span>
							<span>{{staticData.follow_nums}}位</span>
						</div>
						<div>
							<span>跟进次数：</span>
							<span>{{staticData.repay_money}}次</span>
						</div>
						<div>
							<span>通话次数：</span>
							<span>{{staticData.call_nums}}次</span>
						</div>
						<div>
							<span>通话时长：</span>
							<span>{{staticData.call_time}}分钟</span>
						</div>
					</div>
					<div class="list_width"
						 style="display: flex; justify-content: space-between; width: 355px; margin-top: 5px;">
						<div>
							<span>本月业绩：</span>
							<span>{{staticData.achievement}}</span>
						</div>
						<div>
							<span>下周上门客户：</span>
							<span style="color: #277dd3;">{{staticData.next_view_nums}}位</span>
						</div>
					</div>
                    <div class="list_width" style="margin-top: 10px;font-weight: bold;">本周工作总结：</div>
                    <Input v-model="form.summarize" type="textarea" :rows="4"/>
                    <div class="list_width" style="margin-top: 10px;font-weight: bold;">遇到的问题或下周需要协助的事项：</div>
                    <Input v-model="form.issue" type="textarea" :rows="4"/>
                </TabPane>
                <TabPane label="月报" name="month">
					<div class="list_width"
						 style="display: flex; justify-content: space-between; width: 946px; margin-top: 20px;">
						<div>
							<span>本月上门客户：</span>
							<span style="color: #277dd3;">{{staticData.view_nums}}位</span>
						</div>
						<div>
							<span>本月签约客户：</span>
							<span style="color: #277dd3;">{{staticData.sign_nums}}位</span>
						</div>
						<div>
							<span>本月进件：</span>
							<span style="color: #277dd3;">{{staticData.client_nums}}件</span>
						</div>
						<div>
							<span>本月放款：</span>
							<span style="color: #277dd3;">{{staticData.loan_money}}笔</span>
						</div>
						<div>
							<span>回款额度：</span>
							<span>{{staticData.repay_money}}元</span>
						</div>
					</div>
					<div class="list_width"
						 style="display: flex; justify-content: space-between; width: 750px; margin-top: 5px;">
						<div>
							<span>本月跟进客户数量：</span>
							<span>{{staticData.follow_nums}}位</span>
						</div>
						<div>
							<span>跟进次数：</span>
							<span>{{staticData.repay_money}}次</span>
						</div>
						<div>
							<span>通话次数：</span>
							<span>{{staticData.call_nums}}次</span>
						</div>
						<div>
							<span>通话时长：</span>
							<span>{{staticData.call_time}}分钟</span>
						</div>
					</div>
					<div class="list_width"
						 style="display: flex; justify-content: space-between; width: 355px; margin-top: 5px;">
						<div>
							<span>本月业绩：</span>
							<span>{{staticData.achievement}}</span>
						</div>
						<div>
							<span>下月上门客户：</span>
							<span style="color: #277dd3;">{{staticData.next_view_nums}}位</span>
						</div>
					</div>
                    <div class="list_width" style="margin-top: 10px;font-weight: bold;">本月工作总结：</div>
                    <Input v-model="form.summarize" type="textarea" :rows="4"/>
                    <div class="list_width" style="margin-top: 10px;font-weight: bold;">遇到的问题或下个月需要协助的事项：</div>
                    <Input v-model="form.issue" type="textarea" :rows="4"/>
                </TabPane-->
            </Tabs>
			<div slot="footer">
				<Button type="primary" @click="save">确定</Button>
			</div>
        </Modal>

    </Card>
</template>

<script>
    import RecordList from './RecordList.vue'
	import CallReport from './components/CallReport.vue'
	import teamRecordList from './teamRecordList.vue'
	import TodayCustomer from './TodayCustomer.vue'
	import VisitingCustomerReport from './VisitingCustomerReport.vue'
	import UserLog from './UserLog.vue'
	import {mapGetters} from "vuex";
	import {beforeReport,saveReport} from '@/api/task'

    export default {
        name: "task",
        components: {
            RecordList,
			teamRecordList,
			TodayCustomer,
			VisitingCustomerReport,
			UserLog,
			CallReport
        },
		computed:{
			...mapGetters(['userInfo', 'token']),
		},
		created(){
			this.loadData();
		},
        data() {
            return {
				bindData:{
					status:'',
					remark:'',
				},
				bindRemarkData:[],
                addRecordShow: false,
				todayCustomerModal:false,
                tabs_value: 'day',
				form: {
					summarize: '',
					issue: '',
				},
				staticData: {

				},
				stateList: [{
						value: 1,
						label: '未处理',
						is_true: 0
					},
					{
						value: 2,
						label: '待跟进',
						is_true: 0
					},
					{
						value: 3,
						label: '邀约中',
						is_true: 0
					},
					{
						value: 6,
						label: '上门未签约',
						is_true: 0
					},
					{
						value: 7,
						label: '已签约',
						is_true: 0
					},
					{
						value: 8,
						label: '进件中',
						is_true: 0
					},
					{
						value: 9,
						label: '银行拒绝',
						is_true: 0
					},
					{
						value: 13,
						label: '已回款',
						is_true: 0
					},
					{
						value: 14,
						label: '资质不符',
						is_true: 0
					},
					{
						value: 15,
						label: '捣乱申请',
						is_true: 0
					},
					{
						value: 16,
						label: '外地申请',
						is_true: 0
					},
					{
						value: 17,
						label: '重复申请',
						is_true: 0
					},
					{
						value: 18,
						label: '短信申请',
						is_true: 0
					}
				],
            }
        },
        methods: {
        	async loadData() {
				let that = this;
				let data = {token: that.token, type:that.tabs_value}
				let res = await beforeReport(that, data);
				if (res.code == 1) {
					this.staticData = res.data;
				}
			},
			save() {
				let that = this;
				that.throttle(async function () {
					let data = {token: that.token, type:that.tabs_value, form: that.form,staticData:that.staticData}
					if(that.staticData.call_nums ==0){
						this.$Message.error('通话次数不能为空');
						return;
					}
					if(that.staticData.call_time ==0){
						this.$Message.error('通话时长不能为空');
						return;
					}
					let res = await saveReport(that, data);
					if (res.code == 1) {
						this.form = {
							summarize: '',
							issue: '',
						};
						this.addRecordShow = false;
						this.$refs['recordList'].getList();
					}
				}, 500)
			},
            AddRecordClick() {
                this.addRecordShow = true;
                this.loadData();
            },
			getTodayCustomerList(){
				this.todayCustomerModal = true;
			},
            addTabsClick(e) {
				this.loadData();
            }
        }
    }
</script>

<style scoped lang="less">
	.text-center{
		height: 580px;
		overflow: scroll;
	}
	.shijian{
		position: relative;
		left: 15px;
	}
	.xiaoxi{
		position: relative;
		left: -120px;
		top: 18px;
	}
	.icon-biao{
		display: flex;
		justify-content: left;
		font-size: 15px;
		margin-bottom: 30px;
	}
	.xiangqing{
		background-color: #F9FAFA;
	}
	.biaoti{
		font-weight: bold;
	}
	.biaogetoubu{
		background-color: #F9FAFA;
		border-bottom: 1px solid #E8EAEC;
	}
	.shuju{
		margin-bottom: 10px;
		text-align: left;
		text-align-last: justify;
		display: flex;
		justify-content: left;
		div{
			margin-right:20px ;
			width: 60px;
		}
	}
	.biaogelimian{
		display: flex;
		justify-content: space-around;
	}
	.shanchu{
		margin-right: 10px;
		color: #54A1F3;
		font-size: 15px;
	}
	.biaotou{
		display: flex;
		justify-content: space-between;
	}

	.xinjianbottom {
		margin-top: 60px;
		display: flex;
		justify-content: left;
	}



	.dialoglist {
		display: flex;
		justify-content: left;
		align-items: center;
		margin-bottom: 20px;
	}

	.assign {
		position: relative;
		left: 80%;
		top: -232px;
	}

	.top-add {
		position: relative;
		width: 30px;
		left: 80%;
		bottom: 30px;
	}

	.input-text {
		margin-top: 30px;
		display: flex;
		justify-content: left;
		align-items: center;

		div {
			margin: 0 10px;
		}
	}

	.top-save {
		position: relative;
		left: 70%;
		top: -30px;
	}

	.cascader {
		width: 380px;
	}

	.multiple {
		display: flex;
		justify-content: left;
		margin-top: 10px;

		.child-div {
			width: 60px;
			height: 20px;
			margin-right: 30px;
			text-align-last: justify;
		}
	}

	.chongzhi {
		position: absolute;
		top: 16px;
		left: 280px;
	}

	.sousuo {
		height: 32px;
		width: 100%;
		margin-bottom: 20px;
	}
	.ivu-table-fixed-header thead tr th{
		text-align: center;
	}
    .list_width {
        div {
            width: 160px;
        }
    }
</style>
